import styled from "styled-components";

export const Container = styled.div`
    padding-top: 1rem;

    .release-date {
        margin: 1rem 0;
        font-size: 120%;
        opacity: 0.5;
    }

    @media (max-width: 968px) {
        display: flex;
        justify-content: center;
        margin: auto;
        align-items: center;

        .release-date {
            margin: 0 0.5rem;
        }
    }
`;
